module.exports = __webpack_public_path__ + "img/image1.1d167f17.png";